import { render, staticRenderFns } from "./BrokerLogin.vue?vue&type=template&id=744bf8b4&scoped=true"
import script from "./BrokerLogin.vue?vue&type=script&lang=js"
export * from "./BrokerLogin.vue?vue&type=script&lang=js"
import style0 from "./BrokerLogin.vue?vue&type=style&index=0&id=744bf8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744bf8b4",
  null
  
)

export default component.exports